<template>
	<div class="login-view">
		<div class="h2 mb-30 w-100 text-center">
			Registration
		</div>
		<ValidationObserver tag="div" class="form" v-slot="{ invalid }">
			<validation-provider :rules="{ required: true }" v-slot="{ errors }">
				<input v-model="name" placeholder="Name" class="w-100" name="Name" />
				<small style="color: red">{{ errors[0] }}</small>
			</validation-provider>
			<validation-provider :rules="{ required: true, email: true }" v-slot="{ errors }">
				<input v-model="email" placeholder="Email" name="Email" class="w-100" />
				<small style="color: red">{{ errors[0] }}</small>
			</validation-provider>
			<validation-provider :rules="{ required: true, min: 8 }" v-slot="{ errors }">
				<input v-model="password" type="password" name="Password"
				       placeholder="Password" class="w-100" />
				<small style="color: red">{{ errors[0] }}</small>
			</validation-provider>
			<c-button tag="button" class="mt-30" :disabled="invalid || inProgress" @click="onSubmit()">
				{{ inProgress ? 'Loading ...' : 'Registration' }}
			</c-button>
		</ValidationObserver>
	</div>
</template>

<script>
import LocalStorageService from '../helpers/localstorageservice';
// LocalstorageService
const localStorageService = LocalStorageService.getService();

export default {
	data() {
		return {
			email: '',
			name: '',
			password: '',
			inProgress: false,
		};
	},
	methods: {
		onSubmit() {
			this.inProgress = true;
			this.$http({
				url: '/v1/auth/register',
				method: 'POST',
				data: {
					email: this.email,
					name: this.name,
					password: this.password,
				},
			})
				.then((resp) => {
					if (resp.data && resp.data.tokens) {
						localStorageService.setToken(resp.data.tokens);
					}
					localStorage.userId = resp.data.user.id;
					this.$store.dispatch('setUser', resp.data.user);
					this.$router.push({ name: 'DayView' });
					this.inProgress = false;
				})
				.catch((e) => {
					if (e.response.status === 400) {
						this.$notify({
							group: 'system',
							title: 'Important message!',
							text: e.response.data.message,
							type: 'error',
						});
					}
					this.inProgress = false;
				});
		},
	},
};
</script>

<style lang="scss">
	.login-view{
		padding: 80px 30px 30px;
		min-height: 82vh;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		.form{
			display: flex;
			flex-direction: column;
			width: 100%;
			input{
				font-size: 18px;
				padding: 10px;
				margin-top: 15px;
				border: 1px solid #ddd;
				margin-bottom: 0;
			}
		}
	}
</style>
